<template>
  <b-modal
    v-model="visible"
    :title="journey ? journey.name : 'Detalhes da Jornada'"
    hide-footer
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
    id="jdm-fullscreen-modal"
    @show="onShow"
    @hidden="onHidden"
  >
    <b-tabs v-model="activeTab" content-class="mt-3" nav-class="nav-tabs-custom">
      <!-- Analytics Tab -->
      <b-tab active>
        <template v-slot:title>
          <i class="bx bx-bar-chart-alt-2 mr-1"></i> Analytics
        </template>
        <div v-if="loadingAnalytics" class="text-center py-5">
          <i class="bx bx-loader-alt bx-spin font-size-24 text-primary"></i>
          <p class="text-muted mt-2 mb-0">Carregando analytics...</p>
        </div>
        <div v-else>
          <JourneyMetrics :metrics="analytics.metrics" />
          <div class="row mt-3">
            <div class="col-md-7">
              <EntriesChart :entries="analytics.entries" />
            </div>
            <div class="col-md-5">
              <JourneyFunnel :funnel="analytics.funnel" />
            </div>
          </div>
        </div>
      </b-tab>

      <!-- Logs Tab -->
      <b-tab>
        <template v-slot:title>
          <i class="bx bx-list-ul mr-1"></i> Logs
        </template>
        <div v-if="!journey" class="text-center py-5">
          <i class="bx bx-loader-alt bx-spin font-size-24 text-primary"></i>
        </div>
        <ExecutionLogs
          v-else
          :journey-id="journey.id"
          :logs="analytics.logs"
          :total-nodes="totalNodes"
          @load-logs="loadLogs"
          @open-timeline="openTimeline"
        />
      </b-tab>
    </b-tabs>

    <!-- Participant Timeline Modal -->
    <ParticipantTimelineModal
      v-model="showTimeline"
      :journey-id="journey ? journey.id : null"
      :enrollment-id="timelineEnrollmentId"
    />
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import JourneyMetrics from '../analytics/JourneyMetrics.vue'
import JourneyFunnel from '../analytics/JourneyFunnel.vue'
import EntriesChart from '../analytics/EntriesChart.vue'
import ExecutionLogs from '../logs/ExecutionLogs.vue'
import ParticipantTimelineModal from './ParticipantTimelineModal.vue'

export default {
  components: {
    JourneyMetrics,
    JourneyFunnel,
    EntriesChart,
    ExecutionLogs,
    ParticipantTimelineModal
  },
  props: {
    value: { type: Boolean, default: false },
    journeyId: { type: [Number, String], default: null },
    initialTab: { type: String, default: 'analytics' }
  },
  data () {
    return {
      activeTab: 0,
      loadingAnalytics: false,
      showTimeline: false,
      timelineEnrollmentId: null
    }
  },
  computed: {
    visible: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    ...mapState('journeyBuilder', [
      'journey', 'analytics'
    ]),
    totalNodes () {
      if (!this.journey || !this.journey.nodes) return 0
      return this.journey.nodes.filter(n => !n.parent_node_id).length
    }
  },
  watch: {
    initialTab: {
      immediate: true,
      handler (val) {
        const tabMap = { analytics: 0, logs: 1 }
        this.activeTab = tabMap[val] || 0
      }
    }
  },
  methods: {
    ...mapActions('journeyBuilder', {
      getJourney: 'GetJourney',
      getAnalytics: 'GetAnalytics',
      getLogs: 'GetLogs'
    }),
    async onShow () {
      if (!this.journeyId) return

      this.loadingAnalytics = true

      try {
        await this.getJourney(this.journeyId)
        await Promise.all([
          this.getAnalytics(this.journeyId),
          this.getLogs({ id: this.journeyId, params: { limit: 20, page: 1 } })
        ])
      } catch (e) {
        console.error('Failed to load journey details', e)
      } finally {
        this.loadingAnalytics = false
      }
    },
    onHidden () {
      // cleanup
    },
    loadLogs (params) {
      if (this.journey) {
        this.getLogs({ id: this.journey.id, params })
      }
    },
    openTimeline (enrollmentId) {
      this.timelineEnrollmentId = enrollmentId
      this.showTimeline = true
    }
  }
}
</script>

<style>
#jdm-fullscreen-modal > .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  bottom: 0;
}
#jdm-fullscreen-modal > .modal-dialog > .modal-content {
  height: 100%;
  border-radius: 0;
  border: none;
  display: flex;
  flex-direction: column;
}
#jdm-fullscreen-modal > .modal-dialog > .modal-content > .modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
}
#jdm-fullscreen-modal > .modal-dialog > .modal-content > .modal-header {
  background: #f8f9fb;
  border-bottom: 1px solid #e2e5eb;
}
#jdm-fullscreen-modal > .modal-dialog > .modal-content > .modal-header .modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #15181e;
}
#jdm-fullscreen-modal > .modal-dialog > .modal-content > .modal-header > .close {
  font-size: 2rem;
  font-weight: normal;
}
</style>
